import styled from "styled-components";

export const SubtitlesMenu = styled.div`
  position: absolute;
  bottom: 120%;
  right: 0;
  
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  background-color: rgba(0, 0, 0, 0.9);
  padding: 30px;
  border-radius: 12px;
  text-align: center;

  p {
    font-size: ${({ theme }) => theme.old.fonts.size.semilarge};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    line-height: 28px;
    margin-bottom: 16px;
  }
`

export const Option = styled.button`
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
  line-height: 24px;

  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: color 200ms;

  color: ${({ theme, $isActive }) => $isActive
    ? theme.old.colors.primary
    : 'white'
  };

  :hover {
    color: ${({ theme, $isActive }) => $isActive
      ? theme.old.colors.primary
      : '#BBB'
    };
  }
`